
  import { format } from 'date-fns'
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'CalendarHeader',
    props: {
      day: {
        type: Date,
        required: true,
      },
      localeOptions: {
        type: String,
        required: true,
      },
    },
    emits: ['displayNextMonth', 'displayPreviousMonth'],
    setup(props, { emit }) {
      return { emit, format }
    },
  })
